import React from 'react';
import { IClearFieldButton } from './interfaces';
import { IconButton, Stack } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export const ClearFieldButton: React.FC<IClearFieldButton> = ({
  children,
  show = true,
  onClear,
}): JSX.Element => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {children}
      {show && (
        <IconButton size="small" aria-label="Clear country" onClick={onClear}>
          <ClearIcon
            sx={{
              width: '20px',
              height: '20px',
            }}
          />
        </IconButton>
      )}
    </Stack>
  );
};
